import { white, black } from "../common/colors";
import green from "@material-ui/core/colors/green";

// original file: https://github.com/devias-io/react-material-dashboard/blob/master/src/theme/palette.js
export default {
  common: {
    black,
    white,
    neutral: "#E4E7EB",
    muted: "#9EA0A4"
  },
  primary: {
    contrastText: white,
    main: "#003767", //"#00bfd2",
    light: "#ccd7e0", //"#2bdbec",
    dark: "#003767"
  },
  secondary: {
    contrastText: white,
    main: "#F78E1E", //"#7d58ff",
    light: "#f9af61",
    dark: "#ac6315"
  },
  success: {
    contrastText: white,
    main: green[600],
    light: "lightgreen",
    dark: green[600]
  },
  info: {
    contrastText: white,
    main: "#1070CA",
    light: "#F1FBFC",
    dark: "#007489"
  },
  warning: {
    contrastText: white,
    main: "#FFB822",
    light: "#FDF8F3",
    dark: "#95591E"
  },
  danger: {
    contrastText: white,
    main: "#ED4740",
    light: "#F16E6A",
    dark: "#BF0E08"
  },
  text: {
    primary: "#12161B",
    // secondary: "#66788A",
    light: "#7a828a",
    veryLight: "#A1ADBA",
    secondary: "#535353",
    disabled: "#A6B1BB",
    darkBackground: "#ffffff"
  },
  background: {
    default: white,
    /*  light: "#f6f6f6",  */
    light: "#f5f7fa",
    paper: white,
    mainLight: "#002c52", //"#313e50",
    main: "#002648", //"#2b3544",
    mainDark: "#001b33" //"#232e3c"
  },
  border: "#DFE3E8",
  divider: "#DFE3E8",
  dividerDark: "#443f5a"
};
